import { set } from "@/utils/vuex";

export default {
  setBusinessList: set("list"),
  setCurrentProfile: set("currentProfile"),
  setFilteredBusinesses: set("filteredList"),
  setKeywordToBusinessID: set("keywords"),
  setServices: set("services"),
  setTestimonials: set("testimonials"),
  setSalesEnquiries: set("salesEnquiries"),
  setSalesEnquiryCurrentProfile: set("salesEnquiryCurrentProfile"),
};
